// extracted by mini-css-extract-plugin
export default {"top-section":"styles_top-section__mhel1","topSection":"styles_top-section__mhel1","dot-prefix":"styles_dot-prefix__jU5tz","dotPrefix":"styles_dot-prefix__jU5tz"};